export class UnplannedDeliveryOrder {

    public orderId : string = '';

    public description : string = '';

}
